import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    aging(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodeacc', 'namaacc','tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/aging${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
agingexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodeacc', 'namaacc', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/agingexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_aging_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
agingprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['kodeacc', 'namaacc', 'tgl2', 'view'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/agingprint${str}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
    agingsubmodul(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/apreport/agingsubmodul${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    agingsubmodulexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                axios({
                    url: `/apreport/agingsubmodulexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_agingsubmodul_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    agingsubmodulprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['account', 'namaacc', 'tgl2', 'view'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/apreport/agingsubmodulprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    summary(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/apreport/summary${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    summaryexport(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                axios({
                    url: `/apreport/summaryexport${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `ap_summary_${obj.tgl2}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    summaryprint(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl2', 'view'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/apreport/summaryprint${str}`;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
groupdp() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/apinv/groupdp");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
postgroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/apinv/postgroup");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
rekondb(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/rekondb${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
rekondbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/rekondbexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_rekon_DB_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
rekonkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/rekonkr${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
rekonkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/rekonkrexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_rekon_CR_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
rekondpdb(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/rekondpdb${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
rekondpdbexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/rekondpdbexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_rekon_dpinv_DB_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
rekondpkr(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/rekondpkr${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
rekondpkrexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'kodeacc', 'namaacc', 'tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/rekondpkrexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_rekon_dpinv_CR_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
dpinvsmry(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'namaacc', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/dpinvsmry${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
dpinvsmryexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['account', 'namaacc', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/dpinvsmryexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Saldo_DpInv${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},  
trxvendor(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/trxvendor${str}`;
            const { data } = await axios.get(url);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
trxvendorexport(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/apreport/trxvendorexport${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `ap_trx_vendor_${obj.tgl2}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
trxvendorprint(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['vendor', 'vendorinfo', 'matauang', 'tgl2', 'alltrx'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/apreport/trxvendorprint${str}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}

};